import template from './templates/dropdown-html-kt.tmpl.html';

export default function DropdownHtmlKT($document, $parse, $timeout) {
    'ngInject';

    return {
        transclude: true,
        template,
        restrict: 'E',
        scope: {
            options: '=options',
            model: '=model',
            details: '@',
            styling: '@',
            currentValue: '@',
        },
        link: function($scope, elem, attr) {
            $scope.id = attr.details;
            $scope.btnId = $scope.id + 'Menu';
            $scope.style = attr.styling;
            $scope.element = null;
            $scope.btn = null;
            $scope.opened = false;
            $scope.content = attr.content;
            $timeout(function() {
                $scope.element = angular.element('#' + $scope.id);
                $scope.btn = angular.element('#' + $scope.btnId);
            }, 100);
            $scope.setItem = function(item) {
                $scope.model = item;
                $scope.clickOutsideDropdown();
            };
            $scope.openDropdownMenu = function() {
                const element = angular.element(document).find('.travellers-dropdown.active');
                const body = angular.element(document).find('body');
                $timeout(() => {
                    body.addClass('dropdown-open');
                }, 400);
                $scope.element.toggleClass('active');
                $scope.btn.add('active');
                if ($scope.element.hasClass('active')) {
                    $scope.opened = true;
                    $scope.expanded = true;
                } else {
                    $scope.btn.remove('active');
                    $scope.opened = false;
                    $scope.expanded = false;
                }
                if (element.length === 0) {
                    body.removeClass('dropdown-open');
                }
            };
            $scope.clickOutsideDropdown = function() {
                if ($scope.element.hasClass('active') && $scope.opened) {
                    $scope.element.removeClass('active');
                    $scope.btn.removeClass('active');
                    $scope.opened = false;
                    $scope.expanded = false;
                }
            };
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/dropdown-kt-html.directive.js